import type { Strings } from "../i18n/strings";
import type { Gate, Lang } from "../lib/types";
import { resourcesFor, type Resource } from "../lib/crisis";

// S6 · 위기 안전면 — 평문·고대비. 시적 위로 0. 구약톤/달빛 무드 절대 묻지 않음.
function ResRow({ r }: { r: Resource }) {
  const isPhone = !r.href && /^[\d\-\s]+$/.test(r.value);
  const isUrl = !r.href && !isPhone && /\.[a-z]{2,}/i.test(r.value);
  const href = r.href ?? (isPhone ? `tel:${r.value.replace(/[\s-]/g, "")}` : isUrl ? `https://${r.value.replace(/^https?:\/\//, "")}` : undefined);
  const external = Boolean(r.href) || isUrl;
  const inner = (
    <>
      <div>
        <div className="crisis-res-label">{r.label}</div>
        {r.note && <div className="crisis-res-note">{r.note}</div>}
      </div>
      <div className="crisis-res-value">{r.value}</div>
    </>
  );
  const cls = `crisis-res${r.primary ? "" : " small"}`;
  return href ? (
    <a className={cls} href={href} target={external ? "_blank" : undefined} rel="noreferrer">
      {inner}
    </a>
  ) : (
    <div className={cls}>{inner}</div>
  );
}

// gate=harm: 타인 해악 차단면(평문, 위로·면죄 안 함). gate=self_crisis: 자기 위기(따뜻). 둘 다 실제 리소스 연결.
export default function Crisis({ t, lang, gate = "self_crisis", onClose }: { t: Strings; lang: Lang; gate?: Gate; onClose: () => void }) {
  const harm = gate === "harm";
  return (
    <div className="screen crisis">
      <h1 className="crisis-title">{harm ? t.harmTitle : t.crisisTitle}</h1>
      <p className="crisis-body">{harm ? t.harmBody : t.crisisBody}</p>
      <div className="crisis-list">
        {resourcesFor(lang).map((r, i) => (
          <ResRow key={i} r={r} />
        ))}
      </div>
      <button className="crisis-close" onClick={onClose}>
        {t.close}
      </button>
    </div>
  );
}
